import * as Constant from './constant';

export const initialState = { data: [], loading: false, error: false };

const logReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constant.LIST_LOG:
      return {
        ...state,
        loading: true,
        data: [],
        error: false,
      };
    case Constant.LIST_LOG_SUCCESS:
      return {
        ...state,
        loading: false,
        // totalCount: action.payload.total,
        data: action.payload.logreports,
        error: false,
      };
    case Constant.LIST_LOG_ERROR:
      return {
        ...state,
        loading: false,
        data: [],
        error: true,
      };


    default:
      return state;
  }
};

export default logReducer;
